import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { ProjectMapLayer } from '@core/entities/project/ProjectMapLayer'
import {
  projectMapsKeys,
  RequestTypes,
} from '@core/react-query/features/projects/maps'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useUpdateProjectMapLayer = (
  options?: UseMutationOptions<
    ProjectMapLayer,
    RequestErrorType,
    RequestTypes['updateProjectMapLayer']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...projectMapsKeys.updateProjectMapLayer,
    ...options,
    retry: 0,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries(
        projectMapsKeys.byProjectMapConfiguration({
          projectId: variables.projectId,
        }),
      )
    },
  })
}
